import {InputText} from 'primereact/inputtext';
import React, {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {PropTypes} from 'prop-types';
import { t } from 'i18next';
import StringUtils from '../utils/StringUtils';

export const SidebarSearch = ({rendered}) => {
    const [text, setText] = React.useState(undefined);

    useEffect(() => {
        if (!rendered) {
            setText(undefined);
        }
        return () => {
            unClickAllInnerItems();
        };
    }, [rendered]);

    const isChildItem = (item) => {
        const parent = item?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode;
        if (parent && parent.classList.contains('pro-sub-menu')) {
            return true;
        }
        return false;
    };
    const clickInnerItem = (parent) => {
        if (!parent.classList.contains('open')) parent.firstChild.click();
    };
    const unClickInnerItem = (parent) => {
        if (parent.classList.contains('open')) parent.firstChild.click();
    };
    const displayItem = (itemText, searchText, item) => {
        if (!itemText.toUpperCase().includes(searchText.toUpperCase())) {
            item.style.display = 'none';
            return;
        }
        item.style.display = '';
    };
    const unClickAllInnerItems = () => {
        Array.from(document.getElementsByClassName('pro-menu-item')).forEach((item) => {
            unClickInnerItem(item?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode);
        });
    };
    const subMenuClicked = (item, itemText, value) =>{
        const child = item.lastChild;
        if (item.innerText.toUpperCase().includes(value.toUpperCase())) {
          displayItem(itemText, value, item);
        } else {
          displayItem(child.innerText, value, item);
        }
    }
    const handleSearchChange = (e) => {
        const value = e.currentTarget.value;
        if (value.length >= 19) {
          return;
        }
        setText(value);
        Array.from(document.getElementsByClassName('pro-menu-item')).forEach((item) => {
          const itemText = item.innerText.toUpperCase();
          if (StringUtils.isBlank(value) && isChildItem(item)) {
            unClickInnerItem(item?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode);
          }
          if (item.classList.contains('pro-sub-menu')) {
            subMenuClicked(item, itemText, value);
          } else {
            displayItem(itemText, value, item);
            if (isChildItem(item)) {
              clickInnerItem(item?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode);
            }
          }
        });
      };

    return (
        rendered && (
            <div id='searcher' className=''>
                <span className='p-input-icon-right '>
                    <i className='pi pi-search ' />
                    <InputText
                        id='input-search'
                        value={text}
                        onChange={handleSearchChange}
                        placeholder={t('sidebar.find')}
                    />
                </span>
            </div>
        )
    );
};
SidebarSearch.defaultProps = {
    rendered: true,
};

SidebarSearch.propTypes = {
    rendered: PropTypes.bool,
    searchChange: PropTypes.func.isRequired,
};

export default withTranslation()(SidebarSearch);
